var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton",class:{ 'skeleton-loading': _vm.loading }},[_c('v-skeleton-loader',{ref:"skeleton",staticClass:"videoStream_skeleton videoStream_skeleton-1",attrs:{"type":"image, table-heading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }